import { ROUTES } from '~/utils/routes';
import { useEditInternalNewsHeader } from './hooks/useEditInternalNewsHeader';
import { EditInternalNewsHeaderPresentation } from './presentations';

type Props = {
  newsId: number;
};

/**
 * 社内報編集ヘッダー Container コンポーネント
 * API から取得した社内報タイトルをパンくずリスト付きヘッダーに表示する
 */
export const EditInternalNewsHeader: React.FC<Props> = ({ newsId }) => {
  const { title } = useEditInternalNewsHeader({ newsId });

  return (
    <EditInternalNewsHeaderPresentation title={title} indexHref={ROUTES.INTERNAL_NEWS.INDEX} />
  );
};
